import { PRICING_PLANS, POWER_LISTING_TIERS } from 'src/utils/constants';

// The AI credits each plan gives a month, read from the plans the Plans page shows, so the offer a seller
// gets when they run out always matches what they would actually buy.
const PRO_CREDITS = PRICING_PLANS.find((plan) => plan.subscription === 'pro').limits.aiCredits;
const POWER_CREDITS = POWER_LISTING_TIERS.map((tier) => tier.aiCredits).filter(Boolean);
const POWER_FEWEST = Math.min(...POWER_CREDITS);
const POWER_MOST = Math.max(...POWER_CREDITS);

const asNumber = (n) => n.toLocaleString('en-US');

/**
 * The plan a seller who ran out of AI credits can move to for more, or null when no plan offers more.
 *
 * @param {string} plan - the seller's plan ('starter', 'pro', 'power', or an older plan)
 * @param {number} creditsPerMonth - the AI credits their plan gives a month
 * @returns {{ name: string, credits: string } | null}
 */
export function creditUpgrade (plan, creditsPerMonth) {
  if (plan === 'starter') return { name: 'Pro', credits: asNumber(PRO_CREDITS) };
  if (plan === 'pro') return { name: 'Power', credits: `${asNumber(POWER_FEWEST)} or ${asNumber(POWER_MOST)}` };
  if (creditsPerMonth < POWER_MOST) return { name: 'a bigger Power plan', credits: asNumber(POWER_MOST) };
  return null;
}
